import React from 'react';
import { generatePDF } from '../utils/pdf/pdfGenerator';

const BulletinDeSalaire = ({ employeeInfo, salaryDetails, employerInfo }) => {
  const handleGeneratePDF = () => {
    generatePDF(employeeInfo, salaryDetails, employerInfo);
  };

  return (
    <div>
      <button onClick={handleGeneratePDF}>
        Générer le bulletin de paie
      </button>
    </div>
  );
};

export default BulletinDeSalaire;
